import {
  hasCookieConsentForCategory,
  CookieConsentCategory,
} from "@flowstepdesign/shared";
import * as Sentry from "@sentry/react";
import { useRouter } from "@tanstack/react-router";
import { useEffect } from "react";

import { config } from "@/config";

const pageView = (pagePath: string, gaId: string) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("config", gaId, {
      page_path: pagePath,
      cookie_flags: "SameSite=None;Secure",
    });
  }
};

const updateSentryPageContext = (pagePath: string) => {
  Sentry.setContext("router", {
    pathname: pagePath,
  });
  Sentry.addBreadcrumb({
    category: "navigation",
    message: `Navigated to ${pagePath}`,
    level: "info",
  });
};

export const useTrackPageChanges = () => {
  const router = useRouter();

  const pagePath = router.state.location.pathname;
  useEffect(() => {
    if (
      config.google?.tag_id &&
      hasCookieConsentForCategory(CookieConsentCategory.enum.analytics)
    ) {
      pageView(pagePath, config.google.tag_id);
    }
    // Always update Sentry context with current page, regardless of analytics consent
    updateSentryPageContext(pagePath);
  }, [pagePath]);
};
